import { BooleanField, ChipField, Datagrid, List, ReferenceArrayField, ReferenceField, SingleFieldList, TextField } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { Counter } from '../../components/Counter';
import { IndexField } from '../../components/IndexField';
import { ListActions } from '../../components/ListAction';
import { ListIsEmptyPage } from '../../components/ListIsEmptyPage';
import { paginationProps } from '../../components/Paginator';


// const useStyles = makeStyles(() => ({
//   tableCell: {
//     maxWidth: 300,
//     textOverflow: 'ellipsis',
//     whiteSpace: 'nowrap',
//     overflow: 'hidden',
//   },
// }));

export const SessionList = (_props: unknown) => {
  // const classes = useStyles();
  return (
    <List sort={{ field: 'title', order: 'ASC' }} empty={<ListIsEmptyPage />} actions={<ListActions />} title={<CustomTitle />}
      {...paginationProps}>
      <Datagrid rowClick="edit">
        <IndexField label="#" sortable={false} />
        {/* <TextField source="title" cellClassName={classes.tableCell} /> */}
        <ReferenceField source="id" reference="sessions" link="show" label="Title">
          <TextField source="title" />
        </ReferenceField>
        <ReferenceField source="dateId" reference="dates">
          <TextField source="date" />
        </ReferenceField>
        <TextField source="start" />
        <TextField source="end" />
        <ReferenceArrayField reference="locations" source="locationsId">
          <SingleFieldList>
            <ChipField source="title" />
          </SingleFieldList>
        </ReferenceArrayField>
        {/* <ReferenceArrayField reference="speakers" source="speakersId" perPage={3} label="speaker (show max 3)">
          <SingleFieldList>
            <FunctionField
              render={(record: any) => <ChipField record={{ name: `${record.lastname} ${record.firstname}`, id: record.id }} source="name" />}
            />
          </SingleFieldList>
        </ReferenceArrayField> */}
        <ReferenceArrayField reference="speakers" source="speakersId" label="# speaker">
          <Counter />
        </ReferenceArrayField>
        <ReferenceArrayField reference="tags" source="tagsId">
          <SingleFieldList>
            <ChipField source="title" />
          </SingleFieldList>
        </ReferenceArrayField>
        <ReferenceArrayField reference="paths" source="pathsId">
          <SingleFieldList>
            <ChipField source="title" />
          </SingleFieldList>
        </ReferenceArrayField>
        <ReferenceField source="id" reference="sessions" link="show" label="Details">
          <TextField source="details" />
        </ReferenceField>
        <BooleanField source="isSponsored" />
        <TextField source="createdate" />'
        <TextField source="id" />
      </Datagrid>
    </List>
  );
};
